export const dnldVendorWallet = (builder) => ({
    dnldVendorWallet: builder.mutation({
        query: ({ user_id, loggedin_user_id, user_type_id, }) => {
            return {
                url: '/download_vendor_wallet_list',
                method: 'GET',
                params: { user_id, loggedin_user_id, user_type_id, },
                headers: {
                    'Content-Type': 'text/csv',
                  },
                  responseHandler: (response)=>response.blob(),
            };
        },
    }),
});